<template>
    <aside class="sidebar">
        <div class="brand">
            <a class="brand-link"
               href="#/">
                <img src="//awp-assets.meituan.net/hfe/fep/0302a6c4b5c7692a71f3f904adce12d1/3flogo.svg" />
            </a>
        </div>
        <div class="sidebar-menu">
            <Menu ref="mainMenu"
                  :theme='"dark"'
                  :accordion='true'
                  width='160px'
                  :active-name='activeName'
                  :open-names='openNames'
                  @on-select='navToMenuItem'>
                <template v-for="menuItem in menus">
                    <MenuItem v-if="!menuItem.children&&(menuItem.meta&&!menuItem.meta.notMenu)"
                              :key="menuItem.name"
                              :name="menuItem.name">
                    <Icon v-if="menuItem.meta.icon"
                          :type="menuItem.meta.icon"
                          :key="menuItem.name"></Icon>
                    {{menuItem.meta.title}}
                    </MenuItem>
                    <Submenu v-if="menuItem.children&&(menuItem.meta&&!menuItem.meta.notMenu)"
                             :key="menuItem.name"
                             :name="menuItem.name">
                        <template slot="title">
                            <Icon v-if="menuItem.meta.icon"
                                  :type="menuItem.meta.icon"
                                  :key="menuItem.name"></Icon>
                            {{menuItem.meta.title}}
                            <span :class="$style.menuTips"
                                  v-if="menuItem.name==='jiujingorder' && jiuJingConfirmOrders > 0 ">{{jiuJingConfirmOrders>9?'9+':jiuJingConfirmOrders}}</span>
                        </template>
                        <MenuItem v-if="!subMenu.meta.notMenu"
                                  v-for="subMenu in menuItem.children"
                                  :key="subMenu.name"
                                  :name="subMenu.name">{{subMenu.meta.title}}</MenuItem>
                    </Submenu>
                </template>
            </Menu>
        </div>
    </aside>
</template>
<<script>
import { getRootRoute ,getMenus,getActiveMenuInfo} from "utils/menu";
export default {
    data:function(){
        return {
            menus:[],
            activeName:null,
            openNames:[]
        };
    },
    created(){
        this.routes=this.$router.options.routes;
        this.sfCustoms=this.$store.state.sfCustoms;
        this.rootRoute= getRootRoute(this.routes);
        this.bizUser = this.$store.state.bizUser;
    },
    computed:{
        jiuJingConfirmOrders(){
            return this.$store.state.jiuJingConfirmOrders;
        }
    },
    mounted(){
        this.unregisterRouteHookFn= this.$router.beforeEach((to,from,next)=>{
            next();
            this.updateMenus(to);
        });
        this.updateMenus(this.$route);
    },
    destroyed(){
        if (this.unregisterRouteHookFn) {
            this.unregisterRouteHookFn();
        }
    },
    methods:{
        updateMenus(currentRoute){
            this.menus.splice(0,this.menus.length);
            getMenus(this.routes,currentRoute,this.sfCustoms,this.bizUser).forEach((menuItem)=>{
                this.menus.push(menuItem);
            });
            let activeInfo=getActiveMenuInfo(currentRoute);
            if(activeInfo&&this.$refs.mainMenu){
                let mainMenu= this.$refs.mainMenu;
                this.openNames=activeInfo.openNames||[];
                this.activeName=activeInfo.activeName;
                this.$nextTick(()=>{
                    mainMenu.updateOpened();
                    mainMenu.updateActiveName();
                });
            }
        },
        navToMenuItem(menuName){
            this.$router.push({name:menuName});
        }
    }
}
</script>
<style lang="scss" module>
    .menuTips {
      position: absolute;
      background-color: #ff4116;
      border-radius: 10px;
      right: 3px;
      line-height: 17px;
      padding: 0px 3px;
      top: 16.5px;
      color: hsla(0, 0%, 100%, 1);
    }
</style>
<style lang="postcss" type="text/postcss">
    .sidebar {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      background-color: #26304a;
      background: -moz-linear-gradient(350deg, #26304a, #49547c);
      background: -webkit-linear-gradient(350deg, #26304a, #49547c);
      background: linear-gradient(350deg, #26304a, #49547c);
      font-size: 13px;
      width: 160px;
      display: flex;
      flex-direction: column;
      user-select: none;
      .tbo-menu .tbo-menu-submenu .tbo-menu li {
        padding-left: 52px !important;
      }
      .tbo-menu-item,
      .tbo-menu-submenu-title {
        color: white;
        opacity: 0.7;
      }
      .tbo-menu-item-selected,
      .tbo-menu-dark.tbo-menu-vertical .tbo-menu-submenu .tbo-menu-item-selected {
        position: relative;
        opacity: 1;
        background-color: transparent !important;
        color: #fff !important;
        border-right: none !important;
        &:before {
          content: "";
          position: absolute;
          display: block;
          width: 4px;
          height: 18px;
          top: 16px;
          left: 0;
          background-color: #fff;
        }
      }
      .tbo-menu-vertical {
        .tbo-menu-item,
        .tbo-menu-submenu-title {
          padding: 15px 20px;
          .tbo-icon {
            font-size: 16px;
            line-height: 16px;
            & > i {
              margin-right: 13px;
            }
          }
        }
      }
      .tbo-menu-dark.tbo-menu-vertical,
      .tbo-menu-dark.tbo-menu-vertical {
        .tbo-menu-submenu-title,
        .tbo-menu-item {
          &:hover {
            background-color: #2f3a5a;
            opacity: 1;
          }
        }
      }
      .tbo-menu-dark.tbo-menu-vertical .tbo-menu-opened {
        & .tbo-menu-submenu-title {
          background-color: #2f3a5a;
        }
        background-color: #2f3a5a;
      }
      .tbo-menu-submenu .tbo-menu-submenu-title .tbo-icon-larrow-up {
        transform: rotate(-180deg);
      }
      .tbo-menu-submenu.tbo-menu-opened
        .tbo-menu-submenu-title
        .tbo-icon-larrow-up {
        transform: rotate(0);
      }
      .brand {
        width: 100%;
        position: relative;
        height: 86px;
        text-align: center;
        flex: 0 0 36px;
        .brand-link {
          text-decoration: none;
          cursor: pointer;
          display: block;
          height: 100%;
        }
      }
      .tbo-menu-dark {
        background-color: transparent;
      }
      .tbo-menu-item > i,
      .tbo-menu-submenu-title > i {
        margin-right: 9px;
      }
      .sidebar-menu {
        flex: 1 1 1px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// main.vue?03dbf82c